function iconProps() {
  return {
    width: 30,
    height: 30,
    viewBox: '0 0 24 24',
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 1.7,
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
    'aria-hidden': true,
  }
}

export function IconMissionNetwork() {
  return (
    <svg {...iconProps()}>
      <circle cx="12" cy="12" r="9" />
      <path d="M3 12h18" />
      <path d="M12 3c2.5 2.8 4 6 4 9s-1.5 6.2-4 9" />
      <path d="M12 3c-2.5 2.8-4 6-4 9s1.5 6.2 4 9" />
      <path d="M8 9l-1.5 1" />
      <path d="M16 15l1.5 1" />
      <circle cx="8" cy="9" r="1" fill="currentColor" stroke="none" />
      <circle cx="16" cy="15" r="1" fill="currentColor" stroke="none" />
    </svg>
  )
}

export function IconMissionTarget() {
  return (
    <svg {...iconProps()}>
      <circle cx="12" cy="12" r="8" />
      <circle cx="12" cy="12" r="4" />
      <circle cx="12" cy="12" r="1.2" fill="currentColor" stroke="none" />
      <path d="M18 6l2-2" />
      <path d="M18 6l-1 2" />
      <path d="M18 6l-2 1" />
    </svg>
  )
}

export function IconMissionShield() {
  return (
    <svg {...iconProps()}>
      <path d="M12 2l8 4v6c0 5-3.5 8.5-8 10-4.5-1.5-8-5-8-10V6l8-4z" />
      <path d="M9 12l2 2 4-4" />
    </svg>
  )
}

export function IconMissionHandshake() {
  return (
    <svg {...iconProps()}>
      <path d="M7 11l2.5-2.5a2 2 0 0 1 2.8 0L15 11" />
      <path d="M9 13l1.5 1.5a2 2 0 0 0 2.8 0L15 13" />
      <path d="M4 10V8l2-2" />
      <path d="M20 10V8l-2-2" />
      <path d="M7 11v5" />
      <path d="M17 11v5" />
      <path d="M10 16h4" />
    </svg>
  )
}

export function IconMissionGlobal() {
  return (
    <svg {...iconProps()}>
      <circle cx="12" cy="12" r="9" />
      <path d="M3 12h18" />
      <path d="M12 3c2.2 2.5 3.5 5.5 3.5 9S14.2 18.5 12 21" />
      <path d="M12 3c-2.2 2.5-3.5 5.5-3.5 9S9.8 18.5 12 21" />
      <path d="M5 8h14" />
      <path d="M5 16h14" />
    </svg>
  )
}

export function IconMissionTruck() {
  return (
    <svg {...iconProps()}>
      <path d="M3 7h11v8H3z" />
      <path d="M14 10h4l3 3v2h-7v-5z" />
      <circle cx="7" cy="17" r="2" />
      <circle cx="17" cy="17" r="2" />
      <path d="M3 11h11" />
    </svg>
  )
}

export const aboutMissionIconMap = {
  network: IconMissionNetwork,
  target: IconMissionTarget,
  shield: IconMissionShield,
  handshake: IconMissionHandshake,
  global: IconMissionGlobal,
  truck: IconMissionTruck,
}
